import { generatePath } from "src/utils/generatePath";

type ReportPath =
	| "/api/vendors/deals/:deal_id/deal_inspection_reports"
	| "/api/vendors/deals/:deal_id/deal_completion_reports"
	| "/api/deals/:deal_id/deal_inspection_reports"
	| "/api/deals/:deal_id/deal_completion_reports";

export const createGetDownloadPath =
	(pathPattern: ReportPath) =>
	(dealId: number, imageIds?: readonly number[]): string => {
		const basePath = `${process.env.NEXT_PUBLIC_API_HOST}${generatePath(
			pathPattern,
			{ deal_id: dealId }
		)}`;
		if (imageIds && imageIds.length > 0) {
			const params = new URLSearchParams();
			for (const id of imageIds) {
				params.append("image_ids[]", String(id));
			}
			return `${basePath}?${params.toString()}`;
		}
		return basePath;
	};
